import styled from 'styled-components';

import { purpurMedia } from '@telialt/common-theme/src/purpurSelectors';

export const ImageModeDesktop = styled.img`
    max-width: 4rem;
    max-height: 4rem;
    margin: 0 auto;
`;
export const ImageModeMobile = styled.img`
    max-width: 3rem;
    max-height: 3rem;
    margin: 0 auto;
`;

const imageModeDesktopSelector: string = ImageModeDesktop;
const imageModeMobileSelector: string = ImageModeMobile;

export const DualMode = styled.span.attrs({ role: 'presentation' })`
    ${purpurMedia('sm')`
        width: 3rem;
        ${imageModeDesktopSelector} { display: none; }
        ${imageModeMobileSelector} { display: flex; }
    `}
    ${purpurMedia('lg')`
        width: 4rem;
        ${imageModeDesktopSelector} { display: flex; }
        ${imageModeMobileSelector} { display: none; }
    `}
`;
